import React from 'react';
import { Check, X, HelpCircle, Clock } from 'lucide-react';

/**
 * WHO SAID WHAT, BY NAME — grouped by answer: Available, Not Available, Maybe,
 * Join Late, and, for an event with an invite list, who has not answered yet.
 *
 * Shared by the event's details and each event in the schedule list, so the
 * two never disagree about who is coming.
 */
const GROUPS = [
  {
    status: 'available', label: 'Available', icon: Check, color: 'text-green-600',
    bgColor: 'bg-green-50 dark:bg-green-900/20', borderColor: 'border-green-200 dark:border-green-800',
    textColor: 'text-green-700 dark:text-green-400',
  },
  {
    status: 'not-available', label: 'Not Available', icon: X, color: 'text-red-600',
    bgColor: 'bg-red-50 dark:bg-red-900/20', borderColor: 'border-red-200 dark:border-red-800',
    textColor: 'text-red-700 dark:text-red-400',
  },
  {
    status: 'maybe', label: 'Maybe', icon: HelpCircle, color: 'text-yellow-600',
    bgColor: 'bg-yellow-50 dark:bg-yellow-900/20', borderColor: 'border-yellow-200 dark:border-yellow-800',
    textColor: 'text-yellow-700 dark:text-yellow-400',
  },
  {
    status: 'join-late', label: 'Join Late', icon: Clock, color: 'text-blue-600',
    bgColor: 'bg-blue-50 dark:bg-blue-900/20', borderColor: 'border-blue-200 dark:border-blue-800',
    textColor: 'text-blue-700 dark:text-blue-400',
  },
  // Invited, and not answered yet.
  {
    status: 'invited', label: 'No answer yet', icon: HelpCircle, color: 'text-gray-500',
    bgColor: 'bg-gray-50 dark:bg-gray-800/40', borderColor: 'border-gray-200 dark:border-gray-700',
    textColor: 'text-gray-600 dark:text-gray-400',
  },
];

const EventResponseGroups = ({ responses = [], theme }) => {
  const groups = GROUPS
    .map(g => ({ ...g, people: (responses || []).filter(r => r.status === g.status) }))
    .filter(g => g.people.length > 0);

  if (groups.length === 0) {
    return <p className={`text-sm ${theme.textMuted}`}>Nobody has replied yet.</p>;
  }

  return (
    <div className="space-y-4 max-h-80 overflow-y-auto pr-2">
      {groups.map(({ status, label, icon: Icon, color, bgColor, borderColor, textColor, people }) => (
        <div key={status} className={`p-3 rounded-lg border ${borderColor} ${bgColor}`}>
          <div className="flex items-center gap-x-2 mb-3">
            <Icon className={`w-4 h-4 ${color}`} />
            <span className={`font-medium ${textColor}`}>
              {label} ({people.length})
            </span>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
            {people.map(r => (
              <div
                key={r.userId}
                className={`px-3 py-2 rounded ${theme.backgroundSecondary} ${theme.text} text-sm`}
              >
                {r.username}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default EventResponseGroups;
